import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { getCsrfToken } from "@/lib/httpClient";

getCsrfToken().catch(() => {});

// O service worker é o que permite push e o ícone na tela inicial. Registrar
// depois do load para não disputar banda com o primeiro render.
window.addEventListener("load", () => {
  import("@/lib/pwa").then(({ registrarServiceWorker }) => registrarServiceWorker());
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
